import { render, staticRenderFns } from "./bundling.vue?vue&type=template&id=641fb406&scoped=true"
import script from "./bundling.vue?vue&type=script&lang=js"
export * from "./bundling.vue?vue&type=script&lang=js"
import style0 from "./bundling.vue?vue&type=style&index=0&id=641fb406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fb406",
  null
  
)

export default component.exports